<template src="./PendingSchedule.html" />

<script>
import moment from "moment";
import mixins from "@/Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      showWebTable: true,
      popupRefuse: false,
      pendency: [],
      idConsult: null,
      idDoctorTr: null,
      popupAgendamento: false,
      selected: [],
      clinics: [],
      interval: [],
      newDate: false,
      numHorarios: 0,
      initialDate: "",
      disabledDate: true,
      dateUSFormat: "",
      dateUSFormat1: "",
      dateUSFormat2: "",
      hourSelected: undefined,
      hourSelected1: undefined,
      hourSelected2: undefined,
      clinicSelected: undefined,
      clinicSelectedName: undefined,
      chosenClinicId: undefined,
      clinicName: "",
      scheduling: {
        price: ""
      },
      patient: {
        name: "",
        phone: "",
        age: "",
        email: ""
      },
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  mounted() {
    this.getScheduled()
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width <= 670) {
        vm.showWebTable = false;
      } else {
        vm.showWebTable = true;
      }
    },
    confirmed() {
      if (!this.dateUSFormat || !this.dateFormatted || !this.hourSelected) {
        this.$vs.notify({
          title: "Por favor",
          text: "Preencha todos os campos!",
          color: "warning",
          icon: "error"
        })
      } else {
        this.axios.options(
          `${this.$store.state.filooServer}doctor/schedules/${this.scheduling.id}/accept-doctor`,
          { headers: { Authorization: this.$session.get("bearer") }}
        )
          .then(() => {
            this.requestPutSchedules();
          })
          .catch((error) => {
            console.error(error);
          })
      }
    },
    requestPutSchedules() {
      const vm = this;
      let idPendency = vm.scheduling.id;
      let scheduleDoctorId = vm.idDoctorTr;
      var formatDateToBR = moment(String(vm.dateUSFormat)).format("DD/MM/YYYY");
      var formatDateToBR1 = moment(String(vm.dateUSFormat1)).format(
        "DD/MM/YYYY"
      );
      var formatDateToBR2 = moment(String(vm.dateUSFormat2)).format(
        "DD/MM/YYYY"
      );

      var appointment = {
        dateHour: formatDateToBR + " " + vm.hourSelected,
        dateHour1: null,
        dateHour2: null,
        scheduleDoctorId: scheduleDoctorId,
        attendanceType: vm.patient.attendanceType,
        kindAttendance0: vm.patient.attendanceType === 1 ? "presencial" : "tele",
        kindAttendance1: vm.patient.attendanceType === 1 ? "presencial" : "tele",
        kindAttendance2: vm.patient.attendanceType === 1 ? "presencial" : "tele",
        webClinicId: vm.clinicSelected
      };
      if(appointment.webClinicId === undefined) {
        appointment.webClinicId = vm.chosenClinicId;
      }
      if (vm.hourSelected1 != undefined && vm.numHorarios > 0) {
        appointment.dateHour1 = formatDateToBR1 + " " + vm.hourSelected1;
      }
      if (vm.hourSelected2 != undefined && vm.numHorarios > 1) {
        appointment.dateHour2 = formatDateToBR2 + " " + vm.hourSelected2;
      }
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "doctor/schedules/" +
            idPendency +
            "/accept-doctor",
          appointment,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function() {
          vm.popupAgendamento = false;
          vm.$swal(
            "Solicitação enviada",
            "Aguarde até que o paciente aceite o agendamento.",
            "success"
          );
          vm.getScheduled();
        })
        .catch(function() {
          vm.$swal("Erro ao aceitar", "error");
        });
    },
    getScheduled() {
      this.axios.get(
        `${this.$store.state.filooServer}doctor/schedules?size=50&sort=id,desc`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ data: { content } }) => (this.pendency = content))
    },
    getClinics(clinicId) {
      this.chosenClinicId = clinicId;
      this.axios.get(
        `${this.$store.state.filooServer}doctor/clinic-doctors`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ data: { content} }) => {
          this.clinics = content

          const selected = content.find((clinic) => clinic.webClinic.id === this.chosenClinicId)

          if (selected) {
            this.clinicSelected = selected.webClinic.id
            this.clinicSelectedName = selected.webClinic.name
          }
        })
    },
    clickBtnConfirmMedicalConsultation(tr) {
      this.clinicSelected = null
      this.clinicSelectedName = null
      this.initialDate = this.dateFormatted(moment(String(this.dateFormatted(tr.date))).format("DD/MM/YYYY"))
      this.dateUSFormat = this.dateFormatted(moment(String(this.dateFormatted(tr.date))).format("DD/MM/YYYY"))

      this.dateUSFormat1 = this.dateFormatted(tr.date)
      this.dateUSFormat2 = this.dateFormatted(tr.date)

      this.interval = tr.interval
      this.popupAgendamento = true
      this.scheduling.price = tr.price
      this.scheduling.id = tr.id
      this.scheduling.specialty = tr.specialty.name

      this.idConsult = tr.id
      this.idDoctorTr = tr.scheduleDoctorId

      this.patient = tr.patient
      this.patient.attendanceType = tr.attendanceType

      this.getClinics(tr.chosenClinicId)
    },
    refuseMedicalConsultation(pendency) {
      this.idConsult = pendency.scheduleDoctorId
      this.popupRefuse = true
    },
    clickBtnRefuseConfirm() {
      const vm = this;
      var idPendency = vm.idConsult
      var appointment = {
        scheduleDoctorId: vm.idDoctorTr
      };
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "doctor/schedules/" +
            idPendency +
            "/refuse-doctor",
          appointment,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          vm.popupRefuse = false;
          if (response.status === 200) {
            vm.getScheduled();
            vm.$swal("Sucesso!", "Consulta cancelada", "success");
          } else {
            vm.$swal("Erro ao cancelar", "error");
          }
        })
        .catch(function() {
          vm.$swal("Erro ao aceitar", "error");
        });
    },
    dateFormatted(date) {
      var day = date.split("/")[0];
      var month = date.split("/")[1];
      var year = date.split("/")[2];

      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    clickNewDate() {
      this.newDate = true;
      this.disabledDate = false;
    },
    clickGoBackDate() {
      this.newDate = false;
      this.dateUSFormat = this.initialDate;
      this.disabledDate = true;
    },
    clickNewHorario() {
      if (this.numHorarios < 3) {
        this.numHorarios = this.numHorarios + 1;
      }
    },
    clickGoBackHorario() {
      if (this.numHorarios > 0) {
        this.numHorarios = this.numHorarios - 1;
      }
    },
    escolheClinica(webClinicId, clinicName) {
      this.clinicSelected =  webClinicId;
      this.clinicSelectedName = clinicName;
    }
  }
};
</script>

<style lang="scss" src="./PendingSchedule.scss" />
